<template>
  <Bootstrap />
</template>

<script>
import Bootstrap from './Bootstrap.vue'

export default {
  name: 'App',
  components: {
    Bootstrap
  }
}
</script>
